import $ from 'jquery'

/**
 * Determines weather or not to show the "Create Dataset Metric/KPI" tooltip
 * @param targetEl {jquery}
 * @returns {boolean}
 */
function shouldShowCreateDatasetMetricTooltip(targetEl) {
	return $(targetEl).hasClass('text-link-emphasized')
}

export { shouldShowCreateDatasetMetricTooltip }
